import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { push } from "connected-react-router";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { func } from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { compose } from "redux";

import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";

import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import AmountField from "pages/_components/fields/formik/AmountField";

import * as i18n from "util/i18n";

const FORM_ID = "transactions.list.filters.amount";

class AmountFilter extends Component {
    static propTypes = {
        resetForm: func.isRequired,
    };

    render() {
        const hadleClear = () => {
            this.props.resetForm();
        };

        return (
            <Form>
                <Container className="container--layout items-center" gridClassName="form-content">
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile">
                        <Field component={AmountField} hideCurrency idForm={FORM_ID} name="minAmount" />
                    </Col>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile">
                        <Field component={AmountField} hideCurrency idForm={FORM_ID} name="maxAmount" />
                    </Col>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="outline" label="transactions.clean.filters" onClick={hadleClear} />
                    </Col>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="primary" label="product.filters.filter" type="submit" />
                    </Col>
                </Container>
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    filters: transactionsSelectors.getFilters(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: (state) => ({
            minAmount: state?.filters?.minAmount || {},
            maxAmount: state?.filters?.maxAmount || {},
        }),
        validationSchema: () =>
            Yup.lazy((values) =>
                Yup.object().shape({
                    minAmount: Yup.object().shape({
                        amount: values.maxAmount.amount
                            ? Yup.number()
                                  .transform((cv, ov) => (ov === "" ? undefined : cv))
                                  .nullable()
                                  .max(values.maxAmount.amount, i18n.get("accounts.movements.filters.minAmount.error"))
                            : Yup.number()
                                  .transform((cv, ov) => (ov === "" ? undefined : cv))
                                  .nullable(),
                    }),
                    maxAmount: Yup.object().shape({
                        amount: values.minAmount.amount
                            ? Yup.number()
                                  .transform((cv, ov) => (ov === "" ? undefined : cv))
                                  .nullable()
                                  .min(values.minAmount.amount, i18n.get("accounts.movements.filters.maxAmount.error"))
                            : Yup.number()
                                  .transform((cv, ov) => (ov === "" ? undefined : cv))
                                  .nullable(),
                    }),
                }),
            ),
        handleSubmit: ({ ...filters }, formikBag) => {
            const { dispatch, isDesktop, onlyPendings, pendingDispatch, handleClickHideFilters } = formikBag.props;
            const { maxAmount, minAmount } = filters;
            const dateFrom = moment().add(-10, "years");
            const dateTo = moment().add(+1, "days");
            if (isDesktop) {
                dispatch(
                    transactionsActions.loadListRequest(
                        { dateFrom, dateTo, pageNumber: 1, maxAmount: maxAmount.amount, minAmount: minAmount.amount },
                        onlyPendings,
                        pendingDispatch,
                        false,
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    transactionsActions.setFilters({
                        filter: "amount",
                        dateFrom,
                        dateTo,
                        pageNumber: 1,
                        maxAmount: maxAmount.amount,
                        minAmount: minAmount.amount,
                    }),
                );
                dispatch(push(`/transactions/list/filters/results`));
            }
            handleClickHideFilters();
        },
    }),
)(AmountFilter);
